// Componentes del módulo de ventas (solo transaccionales)
const IndexVentas = () => import('@/components/ventas/index/Index-ventas.vue');
const NuevaVenta = () => import('@/components/ventas/index/Nueva-venta.vue');
const EditarVenta = () => import('@/components/ventas/index/Editar-venta.vue');
const NuevaNCDesdeVenta = () => import('@/components/ventas/index/Nueva-nc-desde-venta.vue');
const NuevaNDDesdeVenta = () => import('@/components/ventas/index/Nueva-nd-desde-venta.vue');
const NuevaNotaDeCredito = () => import('@/components/ventas/index/Nueva-nota-de-credito.vue');
const NuevaNotaDeDebito = () => import('@/components/ventas/index/Nueva-nota-de-debito.vue');
const DetalleVenta = () => import('@/components/ventas/index/Detalle-venta.vue');
const Presupuestos = () => import('@/components/ventas/presupuestos/Presupuestos.vue');
const NuevoPresupuesto = () => import('@/components/ventas/presupuestos/Nuevo-presupuesto.vue');
const NuevaVentaDesdePresupuesto = () => import('@/components/ventas/presupuestos/Nueva-venta-desde-presupuesto.vue');
const NuevaONDesdePresupuesto = () => import('@/components/ventas/presupuestos/Nueva-on-desde-presupuesto.vue');
const DetallePresupuesto = () => import('@/components/ventas/presupuestos/Detalle-presupuesto.vue');
const NotasDePedido = () => import('@/components/ventas/notas-de-pedido/Notas-de-pedido.vue');
const NuevaNotaDePedido = () => import('@/components/ventas/notas-de-pedido/Nueva-nota-de-pedido.vue');
const DetalleNotaPedido = () => import('@/components/ventas/notas-de-pedido/Detalle-nota-de-pedido.vue');
const NuevaVentaDesdeON = () => import('@/components/ventas/notas-de-pedido/Nueva-venta-desde-on.vue');
const RemitosDeVenta = () => import('@/components/ventas/remitos/Remitos-de-venta.vue');
const NuevoRemitoDeVenta = () => import('@/components/ventas/remitos/Nuevo-remito-de-venta.vue');
const DetalleRemitoDeVenta = () => import('@/components/ventas/remitos/Detalle-remito-de-venta.vue');
const NuevaVentaDesdeSN = () => import('@/components/ventas/remitos/Nueva-venta-desde-remito.vue');

const sales = {
  path: '/ventas',
  redirect: { name: 'Ventas' },
  children: [
    // Ventas principales
    {
      path: '',
      name: 'Ventas',
      component: IndexVentas,
      meta: { title: 'Ventas' },
    },
    {
      path: 'nueva',
      name: 'Nueva venta',
      component: NuevaVenta,
      meta: { title: 'Nueva Venta' },
    },
    {
      path: 'nueva-nota-credito',
      name: 'Nueva nota de credito',
      component: NuevaNotaDeCredito,
    },
    {
      path: 'nueva-nota-debito',
      name: 'Nueva nota de debito',
      component: NuevaNotaDeDebito,
    },
    {
      path: 'editar/:saleId',
      name: 'Editar venta',
      component: EditarVenta,
      props: true,
    },
    {
      path: ':saleId/nota-credito',
      name: 'Nueva NC desde venta',
      component: NuevaNCDesdeVenta,
      props: true,
    },
    {
      path: ':saleId/nota-debito',
      name: 'Nueva ND desde venta',
      component: NuevaNDDesdeVenta,
      props: true,
    },
    {
      path: ':saleId',
      name: 'Detalle de venta',
      component: DetalleVenta,
      props: true,
    },

    // Presupuestos
    {
      path: 'presupuestos',
      name: 'Presupuestos',
      component: Presupuestos,
      meta: { title: 'Presupuestos' },
    },
    {
      path: 'presupuestos/nuevo',
      name: 'Nuevo presupuesto',
      component: NuevoPresupuesto,
    },
    {
      path: 'presupuestos/:budgetId/nueva-venta',
      name: 'Nueva venta desde presupuesto',
      component: NuevaVentaDesdePresupuesto,
      props: true,
    },
    {
      path: 'presupuestos/:budgetId/nueva-nota-pedido',
      name: 'Nueva ON desde presupuesto',
      component: NuevaONDesdePresupuesto,
      props: true,
    },
    {
      path: 'presupuestos/:budgetId',
      name: 'Detalle de presupuesto',
      component: DetallePresupuesto,
      props: true,
    },

    // Notas de pedido
    {
      path: 'notas-de-pedido',
      name: 'Notas de pedido',
      component: NotasDePedido,
      meta: { title: 'Notas de Pedido' },
    },
    {
      path: 'notas-de-pedido/nueva',
      name: 'Nueva nota de pedido',
      component: NuevaNotaDePedido,
    },
    {
      path: 'notas-de-pedido/:orderNoteId/nueva-venta',
      name: 'Nueva venta desde ON',
      component: NuevaVentaDesdeON,
      props: true,
    },
    {
      path: 'notas-de-pedido/:orderNoteId',
      name: 'Detalle de nota de pedido',
      component: DetalleNotaPedido,
      props: true,
    },

    // Remitos
    {
      path: 'remitos',
      name: 'Remitos de venta',
      component: RemitosDeVenta,
      meta: { title: 'Remitos de Venta' },
    },
    {
      path: 'remitos/nuevo',
      name: 'Nuevo remito de venta',
      component: NuevoRemitoDeVenta,
    },
    {
      path: 'remitos/:shippingNoteId/nueva-venta',
      name: 'Nueva venta desde SN',
      component: NuevaVentaDesdeSN,
      props: true,
    },
    {
      path: 'remitos/:shippingNoteId',
      name: 'Detalle de remito de venta',
      component: DetalleRemitoDeVenta,
      props: true,
    },

  ],
};

export default sales;
